import React from 'react'
import styled from 'styled-components'

const StyledNewsItem = styled.div`
  display: flex;
  padding: 24px 0;

  color: #2e384d;
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;

  border-bottom: 1px solid #e5e8f1;

  cursor: pointer;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`

const NewsImage = styled.div`
  width: 60px;
  height: 60px;
  background: url(${(p) => (p.image ? p.image : '')}) #b2d1f9 no-repeat center
    center;
  border-radius: 4px;
  background-size: contain;
`

const NewsContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  margin-left: 20px;
`

const NewsTitle = styled.div`
  margin-bottom: 4px;
  font-weight: 600;
`

const NewsTextPreview = styled.div`
  /* color: green; */
`

export default ({ news, openModal }) => {
  const { time, title, imageThumbUrl, textPreview } = news

  return (
    <StyledNewsItem key={time} onClick={() => openModal(true, news)}>
      <NewsImage image={imageThumbUrl} />
      <NewsContent>
        <NewsTitle>{title}</NewsTitle>
        <NewsTextPreview>{textPreview}</NewsTextPreview>
      </NewsContent>
    </StyledNewsItem>
  )
}
